import { render, staticRenderFns } from "./pricePuListAdminAction.vue?vue&type=template&id=95084e9c&scoped=true"
import script from "./pricePuListAdminAction.vue?vue&type=script&lang=js"
export * from "./pricePuListAdminAction.vue?vue&type=script&lang=js"
import style0 from "./pricePuListAdminAction.vue?vue&type=style&index=0&id=95084e9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95084e9c",
  null
  
)

export default component.exports